export const PendoMetaFields = {
	Id: {
		name: "id",
		beName: "id",
	},
	Name: {
		name: "name",
		beName: "name",
	},
	FirstName: {
		name: "firstName",
		beName: "first_name",
	},
	LastName: {
		name: "lastName",
		beName: "last_name",
	},
	AgentOffice: {
		name: "agentOffice",
		beName: "agent_office",
	},
	Email: {
		name: "email",
		beName: "email",
	},
	MobilePhone: {
		name: "mobilePhone",
		beName: "mobile_phone",
	},
	IsAgent: {
		name: "isAgent",
		beName: "is_agent",
	},
	Role: {
		name: "role",
		beName: "role",
	},
	Permissions: {
		name: "permissions",
		beName: "permissions",
	},
	PartnerType: {
		name: "partnerType",
		beName: "partner_type",
	},
	BusinessUnit: {
		name: "businessUnit",
		beName: "business_unit",
	},
	BusinessUnitHierarchy: {
		name: "businessUnitHierarchy",
		beName: "business_unit_hierarchy",
	},
	Status: {
		name: "status",
		beName: "status",
	},
	CreatedAt: {
		name: "createdAt",
		beName: "created_at",
	},
	StartDate: {
		name: "startDate",
		beName: "start_date",
	},
	Package: {
		name: "package",
		beName: "package",
	},
};
